<style>
.rounded-image-with-stroke {
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  width: 150px;
  cursor: pointer;
}

/* --- Asset Photo Preview: trigger card --- */
.asset-photo-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  background: #f4f6f8;
  box-shadow: 0 4px 14px rgba(20, 30, 50, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.asset-photo-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(20, 30, 50, 0.18);
}

.asset-photo-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.asset-photo-card__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  color: #7367f0;
  font-size: 0.7rem;
  font-weight: 600;
}

.asset-photo-card__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0) 40%, rgba(15, 23, 42, 0.72) 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.asset-photo-card:hover .asset-photo-card__overlay {
  opacity: 1;
}

/* --- Asset Photo Preview: lightbox modal --- */
.asset-photo-modal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
}

.asset-photo-modal .modal-body {
  padding: 0;
}

.asset-photo-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.asset-photo-modal__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #1f2937;
  font-size: 0.95rem;
  font-weight: 700;
}

.asset-photo-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: #f1f2f6;
  color: #4b5563;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.asset-photo-modal__close:hover {
  background: #e94b4b;
  color: #fff;
}

.asset-photo-modal__stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 1.5rem;
  background:
    linear-gradient(45deg, #f4f5f7 25%, transparent 25%),
    linear-gradient(-45deg, #f4f5f7 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #f4f5f7 75%),
    linear-gradient(-45deg, transparent 75%, #f4f5f7 75%);
  background-size: 22px 22px;
  background-position: 0 0, 0 11px, 11px -11px, -11px 0;
  background-color: #fafbfc;
}

.asset-photo-modal__img {
  max-width: 100%;
  max-height: 62vh;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.22);
}

.asset-photo-modal__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1.5rem;
  text-align: center;
}

.asset-photo-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.85rem 1.1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

@media (max-width: 575.98px) {
  .asset-photo-modal__stage {
    min-height: 220px;
    padding: 1rem;
  }
}

/* Full-screen overlay to hide the template swap from the user */
.pdf-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.95);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* Standard styling - NO positioning tricks that break html2canvas */
.pdf-export-wrapper {
  background-color: #ffffff;
  width: 800px;
  margin: 0 auto;
  box-sizing: border-box;
}

.pdf-table {
  width: 100%;
  font-size: 11px;
  font-family: arial, 'helvetica neue', helvetica, sans-serif;
  border-collapse: collapse;
}

.pdf-table td,
.pdf-table th {
  border: 1px solid #dee2e3;
  padding: 8px;
}

.pdf-table th {
  background-color: #dee2e3;
  font-weight: bold;
  text-align: left;
}

.request-table {
  font-size: 10px;
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}

.request-table td,
.request-table th {
  border: 1px solid black;
  padding: 8px 5px;
}
</style>

<template>
  <div>
    <div
v-if="isGenerating"
class="pdf-loading-overlay"
>
      <b-spinner
variant="primary"
style="width: 4rem; height: 4rem;"
class="mb-3"
/>
      <h3 class="text-primary font-weight-bold">
Generating PDF Document...
</h3>
      <p class="text-muted">
Please wait a moment while we format your file.
</p>
    </div>

    <b-modal
      id="modal-picture"
      v-model="pictureModal"
      hide-footer
      hide-header
      centered
      size="lg"
      modal-class="asset-photo-modal"
    >
      <div class="asset-photo-modal__header">
        <div class="asset-photo-modal__title">
          <feather-icon
            icon="ImageIcon"
            size="16"
          />
          <span>Asset Photo</span>
        </div>
        <button
          type="button"
          class="asset-photo-modal__close"
          @click="pictureModal = false"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
      </div>

      <div
        v-if="isImage"
        class="asset-photo-modal__stage"
      >
        <img
          :src="assetPhoto"
          alt="Asset Photo"
          class="asset-photo-modal__img"
          @error="handleImageError"
        >
      </div>
      <div
        v-else
        class="asset-photo-modal__doc"
      >
        <feather-icon
          icon="FileTextIcon"
          size="52"
          class="mb-2 text-primary"
        />
        <h4>Document Preview</h4>
        <p class="text-muted">
This asset is a document file (e.g., PDF).
</p>
        <b-button
          :href="assetPhoto"
          target="_blank"
          variant="primary"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="14"
            class="mr-50"
          />
          Open Document in New Tab
        </b-button>
      </div>

      <div class="asset-photo-modal__footer">
        <b-button
          v-if="isImage"
          :href="assetPhoto"
          target="_blank"
          variant="outline-primary"
          size="sm"
        >
          <feather-icon
            icon="DownloadIcon"
            size="14"
            class="mr-50"
          />
          Download
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="pictureModal = false"
        >
          Close
        </b-button>
      </div>
    </b-modal>

    <div v-show="!isGenerating">
      <b-card
no-body
class="mb-0"
>
        <b-row class="match-height">
          <b-col lg="12">
            <b-card title="Assets Detail">
              <b-row>
                <b-col cols="6">
                  <b-button
                    type="button"
                    variant="primary"
                    class="mr-1"
                    @click="previous()"
                  >
                    <feather-icon
                      icon="ArrowLeftIcon"
                      size="16"
                      class="align-middle"
                    />
                    Back
                  </b-button>

                  <b-button
                    type="button"
                    variant="success"
                    @click="generatePDF()"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      size="16"
                      class="align-middle mr-50"
                    />
                    Download PDF
                  </b-button>
                </b-col>

                <b-col
                  cols="6"
                  class="d-flex justify-content-end align-items-center"
                >
                  <div
                    v-if="assetPhoto != ''"
                    class="asset-photo-card"
                    @click="showModal"
                  >
                    <img
                      v-if="isImage && showImage"
                      :src="assetPhoto"
                      alt="Asset Photo"
                      class="asset-photo-card__img"
                      @error="handleImageError"
                    >
                    <div
                      v-else
                      class="asset-photo-card__doc"
                    >
                      <feather-icon
                        icon="FileTextIcon"
                        size="26"
                      />
                      <span>Document</span>
                    </div>
                    <div class="asset-photo-card__overlay">
                      <feather-icon
                        icon="ZoomInIcon"
                        size="16"
                      />
                      <span>Preview</span>
                    </div>
                  </div>
                </b-col>

                <b-col cols="12">
                  <div class="devider" />
                  <b-form-group
label="Item ID"
label-cols-md="12"
>
                    <b-form-input
:value="item.item ? item.item.item_code : ''"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Asset ID"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_number"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Ref ID"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_ref_id"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Local ID"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_local_id"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Asset Group"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_category"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Description"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_description"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Note"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_note"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="GPS"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_gps"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Date of Acquisition"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_date_of_acquistion"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Acquisition Value"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_acquistion_value"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Depreciation Method"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_depreciation_method"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Residual Value"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_residual_value"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Market Value"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_market_value"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Asset Condition"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_condition"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Asset Address"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_address"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Asset Responsible"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_responsible"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Serial Number"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_serial_no"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Warranty"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_warranty"
readonly
/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div
      v-show="isGenerating"
      ref="documentToPrint"
      class="pdf-export-wrapper"
    >
      <div style="background-color: #0b1a30; padding: 15px 40px; border-bottom: 5px solid #00cfe8;">
        <table
width="100%"
cellspacing="0"
cellpadding="0"
>
          <tr>
            <td
align="left"
valign="middle"
>
              <h1 style="color: #ffffff; margin: 0; font-family: arial, sans-serif; font-size: 24px; letter-spacing: 2px; font-weight: bold;">
ASSET DETAIL
</h1>
            </td>
            <td
align="right"
valign="middle"
>
              <img
                src="YOUR_WHITE_LOGO_URL_HERE.png"
                alt="Logo"
                crossorigin="anonymous"
                style="height: 35px;"
              >
            </td>
          </tr>
        </table>
      </div>

      <div style="padding: 20px 40px; font-family: arial, 'helvetica neue', helvetica, sans-serif;">

        <table
width="100%"
cellspacing="0"
cellpadding="0"
style="font-size: 12px; color: #333333; margin-bottom: 10px;"
>
          <tr>
            <td
width="55%"
valign="top"
>
              <strong style="font-size: 16px;">PT GEOSERVICES</strong><br><br>
              <strong>Asset Report Summary</strong><br>
              Asset Description: {{ item.asset_description || '-' }}<br>
              Asset Responsible: {{ item.asset_responsible || '-' }}
            </td>
            <td
width="45%"
valign="top"
align="right"
>
              <table
width="100%"
cellspacing="0"
cellpadding="0"
style="font-size: 12px;"
>
                <tr><td
align="right"
style="padding-right: 8px;"
>
<strong>Asset ID:</strong>
</td><td
align="right"
style="white-space: nowrap;"
>
{{ item.asset_number || '-' }}
</td></tr>
                <tr><td
align="right"
style="padding-right: 8px;"
>
<strong>Ref ID:</strong>
</td><td
align="right"
style="white-space: nowrap;"
>
{{ item.asset_ref_id || '-' }}
</td></tr>
                <tr><td
align="right"
style="padding-right: 8px;"
>
<strong>Local ID:</strong>
</td><td
align="right"
style="white-space: nowrap;"
>
{{ item.asset_local_id || '-' }}
</td></tr>
                <tr><td
align="right"
style="padding-right: 8px;"
>
<strong>Acquisition Date:</strong>
</td><td
align="right"
style="white-space: nowrap;"
>
{{ item.asset_date_of_acquistion || '-' }}
</td></tr>
                <tr><td
align="right"
style="padding-right: 8px;"
>
<strong>Item Code:</strong>
</td><td
align="right"
style="white-space: nowrap;"
>
{{ item.item ? item.item.item_code : '-' }}
</td></tr>
              </table>
            </td>
          </tr>
        </table>

        <div style="margin-bottom: 10px;">
          <table class="pdf-table">
            <thead>
              <tr>
                <th width="30%">
Specification
</th>
                <th width="70%">
Detail
</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Asset Group / Category</td><td>{{ item.asset_category || '-' }}</td></tr>
              <tr><td>Condition</td><td>{{ item.asset_condition || '-' }}</td></tr>
              <tr><td>Asset Address</td><td>{{ item.asset_address || '-' }}</td></tr>
              <tr><td>GPS Location</td><td>{{ item.asset_gps || '-' }}</td></tr>
              <tr><td>Serial Number</td><td>{{ item.asset_serial_no || '-' }}</td></tr>
              <tr><td>Warranty</td><td>{{ item.asset_warranty || '-' }}</td></tr>
              <tr><td>Acquisition Value</td><td>{{ item.asset_acquistion_value || '-' }}</td></tr>
              <tr><td>Depreciation Method</td><td>{{ item.asset_depreciation_method || '-' }}</td></tr>
              <tr><td>Residual Value</td><td>{{ item.asset_residual_value || '-' }}</td></tr>
              <tr><td>Market Value</td><td>{{ item.asset_market_value || '-' }}</td></tr>
              <tr><td>Additional Notes</td><td>{{ item.asset_note || '-' }}</td></tr>
            </tbody>
          </table>
        </div>

        <div style="page-break-inside: avoid; break-inside: avoid; display: inline-block; width: 100%;">

          <div
v-if="isImage && assetPhoto && showImage"
style="text-align: center; margin-bottom: 10px;"
>
            <h4 style="margin-bottom: 5px; font-size: 14px; color: #333333; text-align: left; padding-bottom: 5px; border-bottom: 1px solid #ccc;">
Asset Photograph
</h4>
            <div style="padding-top: 5px;">
              <img
                :src="assetPhoto"
                alt="Asset Picture"
                crossorigin="anonymous"
                style="width: auto; height: auto; max-width: 200px; max-height: 130px; border-radius: 6px; border: 1px solid #dee2e3; padding: 4px;"
                @error="handleImageError"
              >
            </div>
          </div>

          <table
class="request-table"
style="width: 100%; margin-top: 10px;"
>
            <tr>
              <td
width="50%"
style="padding: 10px 5px;"
>
                <b>Asset Responsible</b><br><br><br>
                {{ item.asset_responsible || '_________________________' }}
              </td>
              <td
width="50%"
style="padding: 10px 5px;"
>
                <b>Approved By</b><br><br><br>
                _________________________<br>
                <b>Manager</b>
              </td>
            </tr>
          </table>

          <div style="margin-top: 10px; font-size: 10px; color: #666; font-style: italic; text-align: right;">
            Print Date : {{ currentDate }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BButton,
  BModal,
  BSpinner,
} from 'bootstrap-vue'
import moment from 'moment-timezone'
import Ripple from 'vue-ripple-directive'
import photoMixin from './mixins/photoMixin'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [photoMixin],
  data() {
    return {
      isGenerating: false,
      pictureModal: false,
      assetPhoto: '',
      isImage: true,
      showImage: true,
      item: { item: {} },
      apiUrl: process.env.VUE_APP_API_URL,
      currentDate: moment().tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss [WIB]'),
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    handleImageError() {
      console.warn('Image failed to load. Hiding to prevent PDF crash.')
      this.showImage = false
    },
    showModal() {
      this.pictureModal = true
    },
    getDetail() {
      const storedItem = JSON.parse(localStorage.getItem('assetDetail'))
      if (storedItem) {
        this.item = storedItem
        if (this.item.asset_photo) {
          const ext = this.item.asset_photo.split('.').pop().toLowerCase()
          this.isImage = ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(ext)

          this.fetchPhotoUrl(this.item.asset_photo).then(url => {
            this.assetPhoto = url || ''
          })
          this.showImage = true
        }
      }
    },
    generatePDF() {
      this.isGenerating = true

      setTimeout(() => {
        const element = this.$refs.documentToPrint
        this.currentDate = moment().tz('Asia/Jakarta').format('YYYY-MM-DD HH:mm:ss [WIB]')

        const opt = {
          margin: 0,
          filename: `Asset-Detail-${this.item.asset_number || 'Report'}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          pagebreak: { mode: ['css', 'legacy'] },
          html2canvas: {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
          },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        }

        window.html2pdf().set(opt).from(element).save()
        .then(() => {
          this.isGenerating = false
        })
        .catch(err => {
          console.error('PDF Generation Failed:', err)
          this.isGenerating = false
        })
      }, 800)
    },
    previous() {
      this.$router.push({ name: 'apps-procurement-assets-list' })
    },
  },
}
</script>
